import { render } from "./loading_svg.vue?vue&type=template&id=ef079968"
import script from "./loading_svg.vue?vue&type=script&lang=js"
export * from "./loading_svg.vue?vue&type=script&lang=js"

import "./loading_svg.vue?vue&type=style&index=0&id=ef079968&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__